import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <polygon
        points="512,28.308 483.692,0 256,227.692 28.308,0 0,28.308 227.692,256 0,483.692 28.308,512 256,284.308 483.692,512 
			512,483.692 284.308,256 		"
      />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 512 512",
  boxSize: "20px",
};

export default IconComp;
